var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3795e3c05ab71289a48825bbce4b923e.svg#g';
                    var viewUrl = 'sprites.3795e3c05ab71289a48825bbce4b923e.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 449 449',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };